import './Product.css';
import ProductContact from './Product/ProductContact.jsx';
import AlphaEssSmileG3S5 from './Product/AlphaEssSmileG3S5';

/** Renders a product page. Pass Hero to show that product (hero + BuiltToGrow + KeyBenefits + IdealFor); otherwise uses default. */
export default function Product({ Hero }) {
  const ProductContent = Hero ?? AlphaEssSmileG3S5;
  return (
    <div className="product-page">
      <div className="page-container">
        <ProductContent />
        <ProductContact />
      </div>
    </div>
  );
}